export const baseURL = 'https://'+process.env.REACT_APP_DOMAIN_NAME+'/v1/'
export const CDN = "https://"+process.env.REACT_APP_CDN_URL+"/public/";
export const websocketURL = `wss:websocket-${process.env.REACT_APP_DOMAIN_NAME}/v1`;
